module.exports = __webpack_public_path__ + "img/icon@2x(5).b5e20c0a.png";